import { ICarePlanMedicalNotesStore } from './types';

const initStore: ICarePlanMedicalNotesStore = {
  items: [],
};

export default initStore;
